import { render, staticRenderFns } from "./TabPoint.vue?vue&type=template&id=6e14adea&scoped=true"
import script from "./TabPoint.vue?vue&type=script&lang=js"
export * from "./TabPoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e14adea",
  null
  
)

export default component.exports